import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import AppLayout from './layouts/AppLayout'
import MonitorPage from './pages/MonitorPage'
import SessionDetailPage from './pages/SessionDetailPage'
import SettingsPage from './pages/SettingsPage'
import ScheduleRulesPage from './pages/ScheduleRulesPage'
import ResetPasswordPage from './pages/ResetPasswordPage'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 重置密码页面（不需要认证） */}
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* 需要认证的页面 */}
        <Route path="/" element={<AppLayout />}>
          <Route index element={<Navigate to="/monitor" replace />} />
          <Route path="monitor" element={<MonitorPage />} />
          <Route path="session/:sessionId" element={<SessionDetailPage />} />
          <Route path="schedule-rules" element={<ScheduleRulesPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App

